"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntryByContentType = void 0;
const tracker_1 = require("../utils/tracker");
const getEntryByContentType = async ({ client, contentType, locale, include = 0, space, trackingApplicationName }) => {
    const response = await client
        .getEntries({
        content_type: contentType,
        locale,
        limit: 1000,
        include
    })
        .catch((error) => {
        throw new Error(`error in fetching page content, ${error}`);
    });
    void (0, tracker_1.trackData)(response, trackingApplicationName, space !== null && space !== void 0 ? space : '');
    return response;
};
exports.getEntryByContentType = getEntryByContentType;
//# sourceMappingURL=getEntryByContentType.js.map